const API_URL = 'https://apizero.kashti.io';
// const API_URL = 'http://127.0.0.1:8000';

export { API_URL };